// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import 'slick-carousel';

//import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import {initCalendar} from "./calendar";
import {initGallery} from "./gallery";

import 'jquery.mb.ytplayer';

import Instafeed from 'instafeed.js';

import BrazeIntegration from "./utilities/braze";

window.Instafeed = Instafeed;

BrazeIntegration();

function ToggleNav() {
    //menu animation
    $('.toggle-cross').toggleClass('active');
    //desktop menu
    $('body').toggleClass('navigation-is-open');
    $('#navigation').toggleClass('navigation--active');
    //mobile menu
    $(".menu-container").toggleClass('mobile-menu');
}

$(function () {

    $('.membership-block').each(function(){
        var str = $(this).find('h3').text();
        if (str.indexOf("Flexi") >= 0) {
            $(this).addClass('flexi-package');
        }
    });

    if($('.highlanders-form-section').length > 0) {
        $('.custom-file').bind('change', function (){
            var input = $(this).find('input');
            var filename = input[0].files[0].name;
            $('label.custom-file-label[for="'+ input.attr('id') +'"]').text(filename);
        });
    }

    if ($('.Tick-list').length > 0) {
        $(".Tick-list").parent("li").parent("ul").addClass("tick-list-wrapper");
    }

    if ($('.timeline').length > 0) {
        $('.timeline').timeline({
            revealbefore: 200,
            anim_class: 'timeline-animate',
        });
    }

    // if ($('#playerAnimation').length > 0) {
    //     $('.player-item').on("mouseover", function(){
    //         $(this).find('#playerAnimation')[0].play();
    //     });

    //     $('.player-item').on("mouseout", function(){
    //         $(this).find('#playerAnimation')[0].pause();
    //     });
    // }

    $('.toggle-cross').click(function(e){
        ToggleNav(e);
    });

    $('.toggle-cross').keypress(function(e){
        if(e.which == 13){ //Enter key pressed
            ToggleNav();
        }
    });

    $(".menu > ul > li span").click(function() {
        if ($(window).width() <= 991) {
            $(this).parent('li').children("ul").fadeToggle(0);
            $(this).parent('li').toggleClass('menu-open');
        }
    });

    const $navbarSearchToggle = $('.toggle-search');
    const $navbarSearch = $('.navbar-search');
    $navbarSearchToggle.on('click', function(e){
        e.preventDefault();
        $('body').toggleClass("show-search");
        setTimeout(()=>($navbarSearch.find('input[type=search]').focus()), 450);
    });

    const calendarEl = document.getElementById('whatson-calendar');

    if (calendarEl) {
        initCalendar(calendarEl);
        $( ".fc-list-event-title" ).append('<a>More Info</a>');
    }


    const galleryEl = document.getElementById('collectionGallery');

    if (galleryEl) {
        initGallery();
    }


    if ($('.collection-slider').length > 0) {
        $('.collection-slider').slick({
            slidesToShow: 3,
            centerMode: true,
            centerPadding: '100px',
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        arrows: false,
                        slidesToShow: 3,
                        centerPadding: '60px',
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        arrows: false,
                        slidesToShow: 3,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        dots: true,
                        centerPadding: '25px',
                    }
                }
            ]
        });
    }

    $('.collection-block .arrow-left').click(function(){
        $('.collection-slider').slick('slickPrev');
    });

    $('.collection-block .arrow-right').click(function(){
        $('.collection-slider').slick('slickNext');
    });

    if ($('.partners-slider').length > 0) {
        $('.partners-slider').slick({
            slidesToShow: 5,
            autoplay: false,
            autoplaySpeed: 2500,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true
                    }
                }
            ]
        });
    }

    $('.partners-block .arrow-left').click(function(){
        $('.partners-slider').slick('slickPrev');
    });

    $('.partners-block .arrow-right').click(function(){
        $('.partners-slider').slick('slickNext');
    });

    if ($('.carousel-slider').length > 0) {
        $('.carousel-slider').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3500,
            infinite: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    if ($('.elemental-sponsors .slick').length > 0) {
        $('.elemental-sponsors .slick').slick({
            slidesToShow: 5,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: false,
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        arrows: false,
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 2
                    }
                }
            ]
        });
    }
});

// $(window).on("resize load scroll", function () {
//     if ($(window).width() < 576) {
//         $(".player-item").each(function () {
//             playerInView($(this));
//         });
//     } else {
//         $(".player-item a").removeClass('inview');
//     }
// });

if ($('.partners-slider').length > 0) {


    var partnerSlider = $('.partners-slider');
    if (partnerSlider.length > 0) {
        $(window).on("scroll load", function () {
            slideInView(partnerSlider);
        });
    }
}

function slideInView(slider) {
    var top_of_element = slider.offset().top;
    var bottom_of_element = slider.offset().top + slider.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
        slider.slick('play');
    } else {
        slider.slick('pause');
    }
}

// function playerInView(player) {
//     var top_of_element = player.offset().top;
//     var bottom_of_element = player.offset().top + player.outerHeight();
//     var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
//     var top_of_screen = $(window).scrollTop();

//     if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
//         player.find('a').addClass('inview');
//         player.find('#playerAnimation')[0].play();
//     } else {
//         player.find('a').removeClass('inview');
//         player.find('#playerAnimation')[0].pause();
//     }
// }

$(document).ready(function () {

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = 145;

    $(window).scroll(function () {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(window).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.

        if (st > 500) {
            $('.header').addClass('page-scrolled');
        } else {
            $('.header').removeClass('page-scrolled');
        }

        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $('.header').removeClass('nav-down').addClass('nav-up');
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('.header').removeClass('nav-up').addClass('nav-down');
            }
        }

        lastScrollTop = st;
    }
});

